import { API_URL } from '../apiUrl';

export const AUTH_MODAL_SIGNUP = 'signup';
export const AUTH_MODAL_LOGIN = 'login';
export const AUTH_MODAL_FORGOT = 'forgot';

export const authApiUrl = (path) => `${API_URL}${path}`;

export const socialAuthHref = (connection, mode = AUTH_MODAL_SIGNUP) => {
  const params = new URLSearchParams({ connection });
  if (mode === AUTH_MODAL_SIGNUP) {
    params.set('screen_hint', 'signup');
  }
  return authApiUrl(`/auth0/login?${params.toString()}`);
};

export const googleAuthHref = (mode = AUTH_MODAL_SIGNUP) => socialAuthHref('google-oauth2', mode);

export const appleAuthHref = (mode = AUTH_MODAL_SIGNUP) => socialAuthHref('apple', mode);

export const openAuth = (setAuthModal, mode = AUTH_MODAL_SIGNUP) => (event) => {
  if (event) {
    event.preventDefault();
  }
  setAuthModal(mode);
};

export async function postAuth(path, body) {
  const response = await fetch(authApiUrl(path), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  let data = {};
  try {
    data = await response.json();
  } catch (e) {
    data = {};
  }

  if (!response.ok || data.ok === false) {
    throw new Error(data.error || 'Request failed');
  }

  return data;
}
